import * as constants from './constants';

const initialState = {
  loading: false,
  data: [],
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_PROJECTS:
    return { ...state, loading: true };
  case constants.GET_PROJECTS_SUCCESS:
    return { ...state, loading: false, data: action.payload };
  case constants.GET_PROJECTS_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.CLEAR_PROJECTS:
    return initialState;
  default:
    return state;
  }
};
